import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import SpeedIcon from '@material-ui/icons/Speed';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ComputerIcon from '@material-ui/icons/Computer';
import TimelineIcon from '@material-ui/icons/Timeline';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import PeopleIcon from '@material-ui/icons/People';
import FolderIcon from '@material-ui/icons/Folder';

const studioHomePage = PageBlueprint.make({
  params: {
    path: '/studio-home',
    title: 'Studio Home',
    icon: <HomeIcon />,
    loader: () =>
      import('./StudioHomePage').then(m => <m.StudioHomePage />),
  },
});

const projectsPage = PageBlueprint.make({
  name: 'projects',
  params: {
    path: '/studio-projects',
    title: 'Projects',
    icon: <AccountTreeIcon />,
    loader: () => import('./ProjectsPage').then(m => <m.ProjectsPage />),
  },
});

const workboardPage = PageBlueprint.make({
  name: 'workboard',
  params: {
    path: '/studio-work',
    title: 'Work',
    icon: <ViewColumnIcon />,
    loader: () => import('./WorkboardPage').then(m => <m.WorkboardPage />),
  },
});

const capacityPage = PageBlueprint.make({
  name: 'capacity',
  params: {
    path: '/studio-capacity',
    title: 'AI Capacity',
    icon: <SpeedIcon />,
    loader: () => import('./CapacityPage').then(m => <m.CapacityPage />),
  },
});

const approvalsPage = PageBlueprint.make({
  name: 'approvals',
  params: {
    path: '/studio-approvals',
    title: 'Approvals',
    icon: <CheckCircleIcon />,
    loader: () => import('./ApprovalsPage').then(m => <m.ApprovalsPage />),
  },
});

const workflowsPage = PageBlueprint.make({
  name: 'workflows',
  params: {
    path: '/studio-workflows',
    title: 'Workflows',
    icon: <TimelineIcon />,
    loader: () => import('./WorkflowsPage').then(m => <m.WorkflowsPage />),
  },
});

const workersPage = PageBlueprint.make({
  name: 'workers',
  params: {
    path: '/studio-workers',
    title: 'Workers',
    icon: <ComputerIcon />,
    loader: () => import('./WorkersPage').then(m => <m.WorkersPage />),
  },
});

const playbooksPage = PageBlueprint.make({
  name: 'playbooks',
  params: {
    path: '/studio-playbooks',
    title: 'Playbooks',
    icon: <MenuBookIcon />,
    loader: () => import('./PlaybooksPage').then(m => <m.PlaybooksPage />),
  },
});

const updatesPage = PageBlueprint.make({
  name: 'updates',
  params: {
    path: '/studio-updates',
    title: 'Updates',
    icon: <SystemUpdateAltIcon />,
    loader: () => import('./UpdatesPage').then(m => <m.UpdatesPage />),
  },
});

const administrationPage = PageBlueprint.make({
  name: 'administration',
  params: {
    path: '/studio-administration',
    title: 'Administration',
    icon: <PeopleIcon />,
    loader: () =>
      import('./AdministrationPage').then(m => <m.AdministrationPage />),
  },
});

const documentsPage = PageBlueprint.make({
  name: 'documents',
  params: {
    path: '/studio-documents',
    title: 'Documents',
    icon: <FolderIcon />,
    loader: () => import('./DocumentsPage').then(m => <m.DocumentsPage />),
  },
});

/** The Studio Home frontend plugin — the Studio overview surface (A2 §6 + A5 capacity) plus the
 * Projects/Portfolio surface (Epics → Features with delivery state). */
export const studioHomePlugin = createFrontendPlugin({
  pluginId: 'studio-home',
  title: 'Studio Home',
  icon: <HomeIcon />,
  extensions: [
    studioHomePage,
    projectsPage,
    workboardPage,
    workflowsPage,
    workersPage,
    playbooksPage,
    capacityPage,
    updatesPage,
    approvalsPage,
    administrationPage,
    documentsPage,
  ],
});

export default studioHomePlugin;
